export default __webpack_public_path__ + "static/media/ethernetOnboard.c143825e.svg";